import axios from 'axios';

const state = {
  list: [],
  fullCount: 0,
  sort: {},
  page: {
    pageSize: 10,
    page: 1,
  },
  filter: '',
  searchList: [],
};

const getters = {
  getOrgById: st => id => st.list.find(o => o._id === id),
};

const actions = {
  async getOrgs({ commit, state: st }) {
    let url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/organizations`;
    url += `?paging=true&page=${st.page.page}&pageSize=${st.page.pageSize}`;
    if (st.sort.field) {
      url += `&sorting=true&sortField=${st.sort.field}&sortDirection=${st.sort.direction}`;
    }
    if (st.filter && st.filter !== '') {
      url += `&filtering=true&filter=${st.filter}`;
    }
    const response = await axios.get(url);
    commit('setOrgs', response.data.organizations);
    commit('setCount', response.data.count);
  },
  async sortOrgs({ commit, state: st, dispatch }, field) {
    if (st.sort && st.sort.field === field) {
      if (st.sort.direction === 'ASC') {
        commit('setSortDirection', 'DESC');
      } else if (st.sort.direction === 'DESC') {
        commit('setSortDirection', 'ASC');
      }
    } else {
      commit('setSortDirection', 'ASC');
      commit('setSortField', field);
    }

    await dispatch('getOrgs');
  },
  async setPage({ commit, dispatch }, page) {
    commit('setPage', page);
    await dispatch('getOrgs');
  },
  setFilter({ commit, dispatch }, filter) {
    commit('setFilter', filter);
    dispatch('getOrgs');
  },
  async getOrg({ commit }, id) {
    const response = await axios.get(`${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${id}`);

    commit('addOrg', response.data.organization);
  },
  async searchOrgsToJoin({ commit }, searchTerm) {
    const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/search/${searchTerm}`;
    const response = await axios.get(url);

    commit('setSearchList', response.data);
  },
  async requestToJoinOrg({ commit }, orgId) {
    const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${orgId}/requestJoin`;
    const response = await axios.post(url);

    commit('auth/addMembershipRequest', response.data, { root: true });
  },
  async adminJoinOrg({ commit }, orgId) {
    const url = `${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${orgId}/adminJoinOrg`;
    const response = await axios.patch(url);

    commit('updateOrg', response.data);
  },
  async updateLocalOrg({ commit }, orgId) {
    const response = await axios.get(`${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${orgId}`);

    commit('updateOrg', response.data.organization);
  },
  resetFilter({ commit }) {
    commit('resetList');
    commit('setSort', {});
    commit('setFilter', '');
  },
  resetSearchList({ commit }) {
    commit('setSearchList', []);
  },
};

const mutations = {
  setOrgs(st, payload) {
    st.list = payload;
  },
  resetList(st) {
    st.list = [];
  },
  setCount(st, payload) {
    st.fullCount = payload;
  },
  setSortDirection(st, payload) {
    st.sort.direction = payload;
  },
  setSortField(st, payload) {
    st.sort.field = payload;
  },
  setSort(st, payload) {
    st.sort = payload;
  },
  setPage(st, page) {
    st.page.page = page;
  },
  setFilter(st, filter) {
    st.filter = filter;
  },
  addOrg(st, org) {
    st.list.push(org);
  },
  setSearchList(st, orgs) {
    st.searchList = orgs;
  },
  updateOrg(st, org) {
    const i = st.list.findIndex(o => o._id === org._id);
    if (i > 0) {
      st.list[i] = org;
    } else {
      st.list.push(org);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
